import React from 'react';
import google_play from "./img/google_play.png";
import app_store from "./img/app_store.png";
import app_gallery from "./img/Appgallery.png";
import Brave from "./img/BRAVE TV LOGO.png";
import { FaXTwitter } from 'react-icons/fa6';
import KHKLOGO from "./img/KHK-LOGO.png";
import './footer.css';
import SubscriptionForm from './Components/subscribeForm.js';

const Footer = () => {
    return (

        <div className="w-full bg-black js-show-on-scroll">
            <div className="max-w-sm md:max-w-2xl lg:max-w-4xl xl:max-w-7xl 2xl:max-w-8xl mx-auto px-4 sm:px-6 md:px-8 lg:px-0 pb-0">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">

                    {/* LEFT COLUMN: App / projects */}
                    <div className="col-span-1 md:col-span-7 mt-10 sm:mt-14 md:mt-20 pt-6 md:pt-10">
                        <div className="pb-2">
                            <h3 className="text-16px xl:text-20px font-primary font-bold tracking-wider text-white fadein text-center md:text-left">
                                BRAVE TV APP
                            </h3>

                            <p className="text-14px xl:text-16px font-primary text-gray-300 pt-2 text-center md:text-left">
                                Check out the BRAVE TV App, a major project from our portfolio. Download now for superior streaming.
                            </p>

                            <div className="grid grid-cols-3 hidden">
                                <div className="col-span-1 xl:ml-6 mt-2">
                                    <a href="https://watch.bravecftv.com/">
                                        <img src={Brave} alt='logo' width="60px" height="50px" />
                                    </a>
                                </div>
                            </div>

                            {/* App store badges - wrap and shrink on small screens */}
                            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 pt-4">
                                <a href="https://play.google.com/store/apps/details?id=com.bravecftv&pli=1">
                                    <img src={google_play} alt="Get it on Google Play" className="w-28 sm:w-32 md:w-36 h-auto" />
                                </a>
                                <a href="https://apps.apple.com/bh/app/brave-tv-mma-fights-more/id1610259996?platform=iphone">
                                    <img src={app_store} alt="Download on the App Store" className="w-28 sm:w-32 md:w-36 h-auto" />
                                </a>
                                <a href="https://appgallery.huawei.com/app/C109851473">
                                    <img src={app_gallery} alt="Explore it on AppGallery" className="w-28 sm:w-32 md:w-36 h-auto" />
                                </a>
                            </div>

                            <div className="pb-2 pt-6 md:pt-4">
                                <h3 className="text-16px xl:text-20px font-primary font-bold tracking-wider uppercase text-white fadein text-center md:text-left">
                                    Discover Our Projects
                                </h3>
                            </div>

                            {/* Project links - stack on small phones, wrap on tablet+ */}
                            <div className="flex flex-col items-center md:items-start sm:flex-row sm:flex-wrap sm:justify-center md:justify-start gap-x-6 gap-y-2 mt-3">
                                <ul className="flex text-14px md:text-16px font-primary white-light-gray-60 uppercase">
                                    <span className="mr-2 text-white">&#8226;</span>
                                    <li><a href="https://bravecf.com/" className="text-gray-300 hover:text-primary">BRAVE CF</a></li>
                                </ul>
                                <ul className="flex text-14px md:text-16px font-primary white-light-gray-60 uppercase">
                                    <span className="mr-2 text-white">&#8226;</span>
                                    <li><a href="https://watch.bravecftv.com/" className="text-gray-300 hover:text-primary">BRAVE TV</a></li>
                                </ul>
                                <ul className="flex text-14px md:text-16px font-primary white-light-gray-60 uppercase">
                                    <span className="mr-2 text-white">&#8226;</span>
                                    <li><a href="https://braveathleisure.com/" className="text-gray-300 hover:text-primary">BRAVE ATHLESIURE</a></li>
                                </ul>
                                <ul className="flex text-14px md:text-16px font-primary white-light-gray-60 uppercase">
                                    <span className="mr-2 text-white">&#8226;</span>
                                    <li><a href="https://khkmediagroup.com/" className="text-gray-300 hover:text-primary">KHK MEDIA GROUP</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN: Logo + subscribe */}
                    <div className="col-span-1 md:col-span-5 flex flex-col items-center md:items-end mt-6 md:mt-0">
                        <a href="https://khkholding.com">
                            <img
                                src={KHKLOGO}
                                alt='logo'
                                className="opacity-reduced w-32 sm:w-36 md:w-40 lg:w-44 xl:w-48 h-auto"
                            />
                        </a>
                        <div className="w-full flex justify-center md:justify-end mt-6 md:mt-8">
                            <SubscriptionForm />
                        </div>
                    </div>
                </div>

                {/* BOTTOM BAR */}
                <div className="grid grid-cols-1 pb-10 mt-8 md:mt-4">
                    <div className="col-span-1 py-4">
                        <hr className="border border-gray-700" />
                        <div className="flex flex-col sm:flex-row sm:justify-between items-center gap-3 sm:gap-0">
                            <div className="flex flex-wrap justify-center sm:justify-start gap-x-4 gap-y-2 pt-4">
                                <a href="/Privacy" className="text-12px md:text-14px text-gray-400 hover:text-white font-primary tracking-wider">
                                    PRIVACY POLICY
                                </a>
                                <a href="/About" className="footerAboutus text-12px md:text-14px text-gray-400 hover:text-white font-primary tracking-wider">
                                    ABOUT
                                </a>
                                <a href="/Contact" className="footerContactus text-12px md:text-14px text-gray-400 hover:text-white font-primary tracking-wider">
                                    CONTACT
                                </a>
                            </div>
                            <div className="flex justify-center sm:justify-end pt-2 sm:pt-4">
                                <p className="text-12px md:text-14px text-gray-400 font-primary tracking-wider whitespace-nowrap">
                                    ©2024<span id="year"></span> KHK HOLDING
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer